import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material';
import { setSession } from 'utils/general';
import { fetchOnBoardData } from 'api/onBoarding';
import FormStep1 from './Step1';
import FormStep2 from './Step2';
import FormStep3 from './Step3';
import FormStep4 from './Step4';
import FormStep5 from './Step5';
import { getFormattedData } from './filter';
import './styles.scss';

/*
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 11,
    left: 'calc(-50% + 4.5px)',
    right: 'calc(50% + 4.5px)',
  },
  active: {
    '& $line': {
      borderColor: '#ad8e56',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#ad8e56',
    },
  },
  line: {
    borderColor: '#f6f6f6',
    borderTopWidth: 1,
    borderRadius: 1,
  },
})(StepConnector);
*/
const QontoConnector = StepConnector;

const PREFIX = 'StepIcons';
const classes = {
  root: `${PREFIX}-root`,
  active: `${PREFIX}-active`,
  complete: `${PREFIX}-complete`,
  circle: `${PREFIX}-circle`,
  inactive: `${PREFIX}-inactive`,
  completed: `${PREFIX}-completed`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    color: '#f6f6f6',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  [`& .${classes.active}`]: {
    color: '#ad8e56',
  },
  [`& .${classes.complete}`]: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    color: '#ad8e56',
  },
  [`& .${classes.circle}`]: {
    width: 9,
    height: 9,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  [`& .${classes.inactive}`]: {
    width: 9,
    height: 9,
    border: '1px solid #ad8e56',
    borderRadius: '50%',
    borderColor: '#ad8e56',
    backgroundColor: '#f6f6f6',
  },
  [`& .${classes.completed}`]: {
    width: 9,
    height: 9,
    borderRadius: '50%',
    backgroundColor: '#ad8e56',
  },
}));

function QontoStepIcon(props) {
  const { active, completed } = props;

  return (
    <Root
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <div className={classes.completed} />
      ) : active ? (
        <div className={classes.circle} />
      ) : (
        <div className={classes.inactive} />
      )}
    </Root>
  );
}

const STEPS = [
  'User Profile',
  'Primary Business Type',
  'Secondary Business Types',
  'Company Profile',
  'Upload your logo',
  'Account preferences',
];

function StepForms() {
  const { stepId } = useParams();
  const activeStep = Number(stepId) || 1;
  const [username, setUsername] = useState('');
  const [onboardData, setBoardData] = useState({});
  const [location, setLocation] = useState();

  useEffect(() => {
    async function fetchBoardingData() {
      let boardingData = await fetchOnBoardData();
      if (boardingData) {
        setUsername(boardingData.login?.username || '');
        if (location) {
          boardingData = {
            ...boardingData,
            organization: {
              ...boardingData?.organization,
              business_address: location,
              contact: {
                ...boardingData?.organization?.contact,
                business_address: location,
              },
            },
          };
        }

        setBoardData(getFormattedData(boardingData));
      }
    }
    fetchBoardingData();
  }, [stepId]);

  useEffect(() => {
    if (!!username && stepId > 0 && stepId < 7) {
      setSession({
        username,
        url: `/app/v2/account-setup/step/${stepId}`,
      });
    }
  }, [stepId, username]);

  const renderForms = () => {
    switch (activeStep) {
      case 1:
        return <FormStep1 formData={onboardData} />;
      case 2:
        return (
          <FormStep2 formData={onboardData}
            setLocation={setLocation}
          />
        );
      case 3:
        return <FormStep3 formData={onboardData} />;
      case 4:
        return (
          <FormStep4 formData={onboardData}
            businessTypeMode="primary"
          />
        );
      case 5:
        return <FormStep4 formData={onboardData} />;
      case 6:
        return <FormStep5 formData={onboardData} />;
      default:
        break;
    }
    return <FormStep5 formData={onboardData} />;
  };

  return (
    <div className="stepflow">
      <section className="stepflow_header">
        <Stepper
          alternativeLabel
          activeStep={activeStep - 1}
          connector={<QontoConnector />}
        >
          {STEPS.map((label, index) => (
            <Step key={label + index}>
              <StepLabel StepIconComponent={QontoStepIcon} />
            </Step>
          ))}
        </Stepper>
      </section>
      {renderForms()}
    </div>
  );
}

export default StepForms;
